var map = {
	"./QuickSwap_logo.png": 340,
	"./arrow-down-blue.svg": 953,
	"./arrow-down-grey.svg": 954,
	"./arrow-right-white.png": 955,
	"./arrow-right.svg": 956,
	"./big_unicorn.png": 957,
	"./blue-loader.svg": 103,
	"./circle-grey.svg": 958,
	"./circle.svg": 959,
	"./coinbaseWalletIcon.svg": 200,
	"./dropdown-blue.svg": 960,
	"./dropdown.svg": 961,
	"./dropup-blue.svg": 962,
	"./ethereum-logo.png": 963,
	"./fortmaticIcon.png": 201,
	"./link.svg": 964,
	"./logo_circle.png": 199,
	"./magnifying-glass.svg": 965,
	"./matic.png": 342,
	"./menu.svg": 966,
	"./metamask.png": 341,
	"./noise.png": 198,
	"./plus-blue.svg": 967,
	"./plus-grey.svg": 968,
	"./portisIcon.png": 202,
	"./qsbg.png": 196,
	"./question-mark.svg": 969,
	"./question.svg": 970,
	"./quick_logo.jpeg": 151,
	"./spinner.svg": 971,
	"./token-list/lists-dark.png": 972,
	"./token-list/lists-light.png": 973,
	"./token-logo.png": 974,
	"./trustWallet.png": 975,
	"./walletConnectIcon.svg": 203,
	"./x.svg": 976,
	"./xl_uni.png": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;